import { store } from 'redux/store';
import _ from 'lodash';
import moment from 'moment';
import { hseEventActions } from '@redux/slices/hse-events';
import { getAppDispatch } from '@utilities/dispatch.util';

const hseEventManipulationJson = ({ initialLogin, data }) => {
  const items = data || [];
  const { hseEvents } = store.getState();

  const allHseEventsMap =
    _.size(hseEvents?.HSEEventList) > 0 && !initialLogin
      ? hseEvents?.HSEEventList.reduce((acc, hseItems) => {
          acc[hseItems.id] = true;
          return acc;
        }, {})
      : {};

  const hseEventsAll = items?.map((hse) => ({
    ...hse,
    status: 'Synced',
    type: 'HSE'
  }));

  let newSyncedHSEEvents = [];
  if (!_.isEmpty(allHseEventsMap)) {
    newSyncedHSEEvents = hseEventsAll.map((ins) => {
      if (!allHseEventsMap[ins.id]) {
        return {
          syncDateCustom: moment().format('YYYY-MM-DD'),
          ...ins
        };
      } else return ins;
    });
  } else newSyncedHSEEvents = hseEventsAll;

  let pendingSyncAndInProgressHSEEvents = [
    ...hseEvents.HSEEventList.filter(
      (t) => t.status === 'Pending sync' || t.status === 'In progress'
    )
  ];

  newSyncedHSEEvents = [
    ...(newSyncedHSEEvents || []),
    ...(pendingSyncAndInProgressHSEEvents || [])
  ];

  return newSyncedHSEEvents;
};

const hseEventDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(hseEventActions.setHseEventList1(data));
};

export { hseEventManipulationJson, hseEventDispatcher };
